import { SaasApiClient } from '@fourthwall/services/dist/SaasApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useCreateSubscriptionPlanMutation = createMutationHook(
  SaasApiClient.createSubscriptionPlan,
  {
    mutationKey: ['createSubscriptionPlanMutation'],
  },
)
